import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApiUrls } from '../../../config/api-urls/api-urls';
import { MainService } from '../../../provider/main.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { Observable } from 'rxjs';
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-transaction-mgt',
  templateUrl: './transaction-mgt.component.html',
  styleUrls: ['./transaction-mgt.component.css']
})
export class TransactionMgtComponent implements OnInit {

  searchForm: FormGroup | any;
  transactionList: any = [];
  itemPerPage: any = 10;
  currentPage: any = 1;
  total: any;
  csvArr: any = [];
  maxDate: Date | any;
  filteredOptions: Observable<string[]> | any;

  constructor(public mainService: MainService) {
    this.mainService.BlockFuture()
  }

  ngOnInit() {
    this.searchForm = new FormGroup({
      'search': new FormControl(''),
      'disease': new FormControl(''),
      'status': new FormControl(''),
      'fromDate': new FormControl(''),
      'toDate': new FormControl('')
    });
    this.getTransactionList();
    const currentYear = new Date()
    this.maxDate = new Date(currentYear);
    this.searchForm.get('search').valueChanges.subscribe((res: any) => {
      let filter = this._filter(res);
      this.transactionList = filter;
      if (res == '') {
        this.getTransactionList();
      }
    })

  }

  _filter(value: any): string[] {
    const filterValue = value.toLowerCase();
    return this.transactionList.filter((option: any) => (option.userId.firstName.toLowerCase() + " " + option.userId.lastName.toLowerCase()).includes(filterValue));
  }

  Reset() {
    this.searchForm.reset();
    this.getTransactionList();

  }
  pagination(page: number) {
    this.currentPage = page;
    this.getTransactionList();
  }
  deleteUserModal() {
    $('#deleteUser').modal('show')
  }

  // get faq by id
  getTransactionList() {
    if (this.searchForm.value.fromDate && this.searchForm.value.toDate) {
      if (this.searchForm.value.fromDate > this.searchForm.value.toDate) {
        this.mainService.errorToast('Start time should be less than end time');
        return
        // this.searchForm.value.fromDate = '';
      }
    }

    let date = new Date(this.searchForm.value.fromDate);
    let year = date.getFullYear();
    let month: any = date.getMonth() + 1;
    let dt: any = date.getDate();

    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }

    let date1 = new Date(this.searchForm.value.toDate);
    let year1 = date1.getFullYear();
    let month1: any = date1.getMonth() + 1;
    let dt1: any = date1.getDate();

    if (dt1 < 10) {
      dt1 = '0' + dt1;
    }
    if (month1 < 10) {
      month1 = '0' + month1;
    }


    const data = {
      fromDate: this.searchForm.value.fromDate,
      toDate: this.searchForm.value.toDate,
      pageNumber: this.currentPage,
      limit: this.itemPerPage
    }

    if (this.searchForm.value.fromDate) {
      data['fromDate'] = year + '-' + month + '-' + dt
    }
    if (this.searchForm.value.toDate) {
      data['toDate'] = year1 + '-' + month1 + '-' + dt1
    }
    this.mainService.showSpinner();
    this.mainService.postApi(ApiUrls.transactionList, data, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.transactionList = res.result ? res.result : '';
        this.transactionList.forEach((ele: any, index: number) => {
          let date = new Date(ele.createdAt);
          let year = date.getFullYear();
          let month: any = date.getMonth() + 1;
          let dt: any = date.getDate();

          if (dt < 10) {
            dt = '0' + dt;
          }
          if (month < 10) {
            month = '0' + month;
          }
          let finalDate = dt + '/' + month + '/' + year;
          this.csvArr.push({
            "Sr. No.": index + 1,
            "Transfer from": ele.userId && ele.userId.firstName + ele.userId && ele.userId.lastName,
            "Transaction ID": ele.transactionId,
            "Program Name": ele.programId && ele.programId.title,
            "Payment Method": "Stripe",
            "Amount": ele.amount + ele.currency,
            "Date of Transaction": finalDate
          })
        });
        this.total = res.paginationData.total;

        this.mainService.hideSpinner();
        // this.mainService.successToast(res.responseMessage);
      } else {
        this.transactionList = res.result ? res.result : '';
        this.mainService.hideSpinner();
      }
    })
  }

  exportCsv() {
    var options = {
      showLabels: true,
      headers: ["Sr. No.", "Transfer from", "Transaction ID", "Program Name"
        , "Payment Method", "Amount", "Date of Transaction"]
    };
    var exportFile = new ngxCsv(this.csvArr, 'Transaction Report', options);
  }

}
